"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  originalSet: _backbone.default.Model.prototype.set,
  originalGet: _backbone.default.Model.prototype.get,
  get: function get(attr) {
    var getters = this.getters || {}; // Call the getter if available

    if (_underscore.default.isFunction(getters[attr])) {
      return getters[attr].call(this);
    }

    return this.originalGet.call(this, attr);
  },
  set: function set(key, value, options) {
    // Normalize the key-value into an object
    var attrs = {};

    if (_underscore.default.isObject(key) || key === null) {
      attrs = key;
      options = value;
    } else {
      attrs = {};
      attrs[key] = value;
    } // Go over all the set attributes and call the setter if available


    var setters = this.setters || {};
    var undefinedAttrs = [];

    for (var attr in attrs) {
      if (_underscore.default.isFunction(setters[attr])) {
        attrs[attr] = setters[attr].call(this, attrs[attr], attrs);

        if (_underscore.default.isUndefined(attrs[attr])) {
          undefinedAttrs.push(attr);
        }
      }
    }

    if (!options || !options.unset) {
      for (var undef_attr in undefinedAttrs) {
        delete attrs[undefinedAttrs[undef_attr]];
      }
    }

    return this.originalSet.call(this, attrs, options);
  },
  addToModel: function addToModel(model) {
    var setFunction = model.set || model.prototype.set;
    var getFunction = model.get || model.prototype.get;

    _underscore.default.extend(model.prototype, GSModel.mixin);

    model.prototype.originalSet = setFunction;
    model.prototype.originalGet = getFunction;
  }
};

var GSModel = _backbone.default.Model.extend(mixin);

GSModel.mixin = mixin;
var _default = GSModel;
exports.default = _default;